import { MouseEventHandler } from 'react';
import * as AlertDialog from '@givebutter/primitives/alert-dialog';

interface BundleOnlyConfirmationDialogProps extends Omit<AlertDialog.AlertDialogRootProps, 'type'> {
    onConfirm: MouseEventHandler<HTMLButtonElement>;
    onCancel: MouseEventHandler<HTMLButtonElement>;
}
const BundleOnlyConfirmationDialog = (props: BundleOnlyConfirmationDialogProps) => {
    const { onConfirm, onCancel, ...rest } = props;

    return (
        <AlertDialog.Root type="warning" {...rest}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content className="max-w-sm p-6">
                    <AlertDialog.Header>
                        <AlertDialog.Icon />
                        <AlertDialog.Close onClick={onCancel} />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>Change to bundle only?</AlertDialog.Title>
                        <AlertDialog.Description>
                            Changing this ticket to bundle only will set its quantity to zero,
                            making it unavailable for individual purchase. Are you sure you want to
                            proceed?
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel onClick={onCancel}>Cancel</AlertDialog.Cancel>
                        <AlertDialog.Action onClick={onConfirm}>Continue</AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const BundleOnlyConfirmationDialogTrigger = AlertDialog.Trigger;

const Root = BundleOnlyConfirmationDialog;
const Trigger = BundleOnlyConfirmationDialogTrigger;

export {
    Root,
    Trigger,
    //
    BundleOnlyConfirmationDialog,
    BundleOnlyConfirmationDialogTrigger,
};
